import {useEffect, useState} from "react";
import axios from "axios";
import {getConfig} from "../../../../services/utils/ConfigUtils";
import {GET_ALL_INTERVISTE_INCOMPLETE_URL, GET_ALL_INTERVISTE_URL} from "../../../../services/utils/ApiUrls";

export default function useGetAllInterviste(stato, pageNumber, idSoggetto, sort, dir) {
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);
	const [interviste, setInterviste] = useState([]);
	const [hasMore, setHasMore] = useState(false);
	
	function getData(stato, idSoggetto) {
		if (idSoggetto) {
			return {
				soggetto: {
					idSoggetto: idSoggetto
				},
				active: null
			}
		}
		switch (stato) {
			default:
				return {
					active: false
				}
			case "Incomplete operatore":
				return {
					active: false,
					stato: "Nuova",
				}
			case "In attesa":
				return {
					active: false,
					stato: "In attesa",
				}
			case "Compilata cittadino":
				return {
					active: false,
					stato: "Compilata cittadino",
				}
			case "In gestione INC":
			case "In gestione CMP":
				return {
					active: true,
				}
		}
	}
	
	function getUrl(stato, sort, dir, pageNum) {
		return (stato === "Complete" || stato === "In gestione CMP") ? GET_ALL_INTERVISTE_URL + pageNum + "/" + sort + "/" + dir : GET_ALL_INTERVISTE_INCOMPLETE_URL + pageNum + "/" + sort + "/" + dir;
	}
	
	useEffect(() => {
		setInterviste([]);
	}, [stato, sort, dir])
	
	useEffect(() => {
		setLoading(true);
		setError(false);
		axios({
			method: "POST",
			url: getUrl(stato, sort, dir, pageNumber),
			data: getData(stato, idSoggetto),
			...getConfig(),
		})
			.then(response => {
				setInterviste(prevState => {
					let newState = [...prevState, ...response.data];
					return newState.filter((object, index) => index === newState.findIndex(obj => JSON.stringify(obj) === JSON.stringify(object)))
				})
				setHasMore(response.data.length > 0);
				setLoading(false);
			}).catch(() => {
			setError(true);
			setLoading(false);
		})
	}, [stato, pageNumber, idSoggetto, sort, dir])
	
	return {loading, error, interviste, hasMore};
}
